/* React */
import React, { useEffect } from "react";

/* Ionic */
import {
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
} from "@ionic/react";
import { close } from "ionicons/icons";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { initialState } from "src/redux/features/toast-message/toastMessageSlice";
import { setToastMessage } from "src/redux/features/toast-message/toastMessageSlice";

/* React Spring */
import { useSpring, animated } from "@react-spring/web";

/* Helper */
import { createToastMessage } from "src/components/shared/toast-message/helper";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./ToastMessage.module.scss";

const ToastMessage: React.FC = () => {
  const dispatch = useDispatch();

  const toastMessageState = useSelector(
    (state: RootState) => state.toastMessage
  );

  const toastMessage = createToastMessage(
    toastMessageState
  );
  const { message, show, icon, color } = toastMessage || {};
  const showIcon = icon ? true : false;

  const animationStyle = useSpring({
    transform: show
      ? "translateY(-10%)"
      : "translateY(100%)",
    opacity: show ? 1 : 0,
    config: { tension: 200, friction: 20 },
    delay: 500,
  });

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (toastMessageState.show) {
      timer = setTimeout(() => {
        dispatch(setToastMessage(initialState));
      }, 8000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, toastMessageState.show]);

  return show ? (
    <animated.div
      data-cy="toast-message"
      style={{
        background: color,
        ...animationStyle,
      }}
      className={styles.toast_message}
    >
      <IonGrid className={styles.grid_container}>
        <IonRow className={styles.row}>
          {showIcon ? (
            <IonCol className={`${styles.col}`} size="1">
              <IonIcon
                className={styles.icon}
                icon={icon}
              />
            </IonCol>
          ) : undefined}
          <IonCol className={`${styles.col}`} size="10">
            <div className={styles.message}>{message}</div>
          </IonCol>
          <IonCol
            className={`${styles.col} ${styles.close_col}`}
            size={showIcon ? "1" : "2"}
          >
            <PrimaryFabButton
              scssProps={{
                margin: "0px",
                height: "32px",
                width: "32px",
                background: "transparent",
                icon: {
                  height: "21px",
                  width: "21px",
                },
              }}
              icon={close}
              ariaLabel={"Close"}
              onClick={() => {
                dispatch(setToastMessage(initialState));
              }}
            />
          </IonCol>
        </IonRow>
      </IonGrid>
    </animated.div>
  ) : undefined;
};

export default ToastMessage;
